(function () {
  'use strict';
  function destinationKey(input) {
    const url = new URL(input, 'https://catsgarage.com.sg');
    const browse = ['filter.p.m.custom.department','filter.p.m.custom.product_category','filter.v.m.custom.food_form','filter.p.m.custom.litter_material'];
    const pairs = [...url.searchParams].filter(([key]) => browse.includes(key)).flatMap(([key,value])=>value.split(',').map(v=>[key,v])).sort((a,b)=>a.join('=').localeCompare(b.join('=')));
    return url.pathname + '?' + new URLSearchParams(pairs).toString();
  }
  if (typeof module !== 'undefined') module.exports = { destinationKey };
  if (typeof document === 'undefined') return;
  const desktop = window.matchMedia('(min-width: 1100px)');
  document.querySelectorAll('.cg-header').forEach(header => {
    const mobile = header.querySelector('.cg-mobile-nav');
    const menus = header.querySelectorAll('[data-cats-menu]');
    function sync() {
      document.documentElement.style.setProperty('--cg-header-bottom', Math.max(0, header.getBoundingClientRect().bottom) + 'px');
      menus.forEach(menu => menu.querySelectorAll('[data-cats-group]').forEach(group => {
        group.open = desktop.matches;
        group.querySelector('summary').tabIndex = desktop.matches ? -1 : 0;
      }));
      if (desktop.matches && mobile) mobile.open = false;
    }
    sync();
    new ResizeObserver(sync).observe(header);
    desktop.addEventListener('change', sync);
    window.addEventListener('scroll', () => document.documentElement.style.setProperty('--cg-header-bottom', Math.max(0, header.getBoundingClientRect().bottom) + 'px'), {passive:true});
    menus.forEach(menu => {
      const groups = menu.querySelectorAll('[data-cats-group]');
      groups.forEach(group => group.addEventListener('toggle', () => {
        if (desktop.matches) { if (!group.open) group.open = true; return; }
        if (group.open) groups.forEach(other => { if (other !== group) other.open = false; });
      }));
      menu.querySelectorAll('[data-cats-destination]').forEach(link => {
        link.addEventListener('click', () => { menu.open = false; if (mobile) mobile.open = false; });
      });
    });
    function highlight() {
      menus.forEach(menu=>{
        let current=false;
        menu.querySelectorAll('[data-cats-destination]').forEach(link=>{
          if(destinationKey(link.href)===destinationKey(window.location.href)){link.setAttribute('aria-current','page');current=true;}
          else link.removeAttribute('aria-current');
        });
        menu.classList.toggle('is-active',current);
      });
    }
    highlight();
    document.addEventListener('cg:discovery-updated',highlight);
    window.addEventListener('popstate',highlight);
    if (mobile) mobile.addEventListener('toggle', () => {
      document.body.classList.toggle('cg-menu-open', mobile.open && !desktop.matches);
      if (mobile.open) {
        const cats = mobile.querySelector('[data-cats-menu]');
        if (cats && !mobile.querySelector('.cg-mobile-nav__group[open]')) cats.open = true;
      }
    });
    header.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        const target = !desktop.matches && mobile?.open ? mobile : event.target.closest('[data-cats-menu][open]');
        if (target) { target.open = false; target.querySelector('summary').focus(); event.preventDefault(); }
      }
      if (event.key === 'Tab' && mobile?.open && !desktop.matches) {
        const focusable = [...mobile.querySelectorAll('summary,a,button,input')].filter(el => el.getClientRects().length);
        const first=focusable[0], last=focusable.at(-1);
        if (event.shiftKey && document.activeElement===first) { last.focus(); event.preventDefault(); }
        else if (!event.shiftKey && document.activeElement===last) { first.focus(); event.preventDefault(); }
      }
    }, true);
    document.addEventListener('click', event => {
      menus.forEach(menu => { if (!menu.contains(event.target)) menu.open = false; });
      if (mobile && !mobile.contains(event.target)) mobile.open = false;
    });
    header.addEventListener('focusout', () => setTimeout(() => {
      if (!header.contains(document.activeElement)) menus.forEach(menu => { menu.open = false; });
    }, 0));
  });
})();
